// Mock data for the portfolio. Replace with real API/DB data later.

export const profile = {
  name: 'Sagar Verma Mirchandani',
  role: {
    en: 'Automotive Development Engineer',
    de: 'Entwicklungsingenieur Automobiltechnik',
  },
  email: 'sagarverma.mir@gmail.com',
  phone: '+49 176 55094456',
  phoneClean: '+4917655094456',
  linkedin: 'https://www.linkedin.com/in/sagarvm/',
  cv: '/cv.pdf',
  location: {
    en: 'Ilmenau, Germany',
    de: 'Ilmenau, Deutschland',
  },
  tagline: {
    en: 'M.Sc. in Automotive Engineering specializing in mechanical design and simulation-driven analysis (FEM/CFD) of engineering systems. Experienced in optimizing designs under realistic load conditions using ANSYS, PrePoMax/CalculiX, and Python-based automation.',
    de: 'M.Sc. Automobiltechnik mit Schwerpunkt auf mechanischer Konstruktion und simulationsgestützter Analyse (FEM/CFD) technischer Systeme. Erfahren in der Auslegungsoptimierung unter realistischen Lastbedingungen mit ANSYS, PrePoMax/CalculiX und Python-basierter Automatisierung.',
  },
  shortBio: {
    en: 'Automotive development engineer focused on fluid systems, structural analysis, and design optimization for high-performance vehicle components.',
    de: 'Entwicklungsingenieur im Automobilbereich mit Fokus auf Fluidsysteme, Strukturanalyse und Konstruktionsoptimierung von Hochleistungs-Fahrzeugkomponenten.',
  },
  languages: [
    { name: { en: 'German', de: 'Deutsch' }, level: 'C1' },
    { name: { en: 'English', de: 'Englisch' }, level: 'C1' },
    { name: { en: 'Hindi', de: 'Hindi' }, level: { en: 'Native', de: 'Muttersprache' } },
  ],
};

// Professional experience (internships + leadership)
export const experience = [
  {
    id: 'exp-benara',
    role: {
      en: 'Internship — Manufacturing & Production',
      de: 'Praktikum — Fertigung und Produktion',
    },
    company: 'Benara Udyog Limited',
    period: 'Jul 2019 – Sep 2019',
    details: {
      en: [
        'Analysed bearing manufacturing processes for efficiency and process stability.',
        'Identified optimisation potential in production workflows.',
        'Derived structured measures to improve process quality and lead times.',
      ],
      de: [
        'Analyse von Fertigungsprozessen für Lager hinsichtlich Effizienz und Prozessstabilität.',
        'Identifikation von Optimierungspotenzialen in Produktionsabläufen.',
        'Ableitung strukturierter Maßnahmen zur Verbesserung von Prozessqualität und Durchlaufzeit.',
      ],
    },
  },
  {
    id: 'exp-endurance',
    role: {
      en: 'Internship — Production & Quality',
      de: 'Praktikum — Produktion und Qualität',
    },
    company: 'Endurance Technologies Limited',
    period: 'Jun 2017',
    details: {
      en: [
        'Analysed manufacturing and testing processes for brake discs and brake calipers.',
        'Evaluated production and procurement processes for efficiency and quality.',
        'Gained insights into industrial testing procedures and quality control.',
      ],
      de: [
        'Analyse von Fertigungs- und Prüfprozessen für Bremsscheiben und Bremssättel.',
        'Bewertung von Produktions- und Beschaffungsprozessen hinsichtlich Effizienz und Qualität.',
        'Einblick in industrielle Prüfverfahren und Qualitätskontrolle.',
      ],
    },
  },
  {
    id: 'exp-sae',
    role: {
      en: 'President — SAE Galgotias Chapter (SAE GCET)',
      de: 'Präsident — SAE Galgotias Chapter (SAE GCET)',
    },
    company: 'Society of Automotive Engineers',
    period: 'Jun 2017 – Jun 2018',
    details: {
      en: [
        'Led an SAE automotive development project, coordinating interdisciplinary teams.',
        'Managed technical results presentation and stakeholder alignment.',
        'Developed leadership and communication skills across a multi-disciplinary team.',
      ],
      de: [
        'Leitung eines SAE-Entwicklungsprojekts und Koordination interdisziplinärer Teams.',
        'Verantwortung für die Ergebnispräsentation und Stakeholder-Abstimmung.',
        'Entwicklung von Führungs- und Kommunikationskompetenzen in einem interdisziplinären Umfeld.',
      ],
    },
  },
];

export const competencies = [
  {
    id: 'cad',
    icon: 'PencilRuler',
    accent: 'steel',
    title: { en: 'CAD & Design', de: 'CAD & Konstruktion' },
    desc: {
      en: 'Parametric modelling, assembly design, and GD&T for automotive components.',
      de: 'Parametrische Modellierung, Baugruppenkonstruktion und Form- und Lagetoleranzen für Automobilkomponenten.',
    },
    tools: ['Autodesk Inventor', 'Ansys SpaceClaim', 'FreeCAD'],
  },
  {
    id: 'simulation',
    icon: 'Waves',
    accent: 'cyan',
    title: { en: 'Simulation (FEA / CFD)', de: 'Simulation (FEA / CFD)' },
    desc: {
      en: 'Finite element analysis and computational fluid dynamics to validate designs under real-world loads.',
      de: 'Finite-Elemente-Analyse und numerische Strömungssimulation zur Validierung von Konstruktionen unter realen Lastfällen.',
    },
    tools: ['ANSYS Mechanical', 'Fluent', 'PrePoMax', 'CalculiX'],
  },
  {
    id: 'product-dev',
    icon: 'Cog',
    accent: 'amber',
    title: { en: 'Product Development', de: 'Produktentwicklung' },
    desc: {
      en: 'From requirements engineering and concept design to prototype validation and iteration.',
      de: 'Von der Anforderungsanalyse und Konzeptentwicklung bis zur Prototypvalidierung und Iteration.',
    },
    tools: ['V-Model', 'DOE', 'Prototyping'],
  },
  {
    id: 'automation',
    icon: 'Terminal',
    accent: 'green',
    title: { en: 'Engineering Automation', de: 'Engineering-Automatisierung' },
    desc: {
      en: 'Python and MATLAB scripts for post-processing, parameter studies, and workflow automation.',
      de: 'Python- und MATLAB-Skripte für Postprocessing, Parameterstudien und Workflow-Automatisierung.',
    },
    tools: ['Python', 'MATLAB', 'NumPy'],
  },
];

export const education = [
  {
    id: 'edu-msc',
    degree: {
      en: 'M.Sc. Automotive Engineering',
      de: 'M.Sc. Automobiltechnik',
    },
    institution: {
      en: 'Technical University of Ilmenau, Germany',
      de: 'Technische Universität Ilmenau, Deutschland',
    },
    period: 'Apr 2021 – Jan 2026',
    details: {
      en: 'Focus areas: mechanical design, vehicle dynamics, computational fluid dynamics, structural simulation.',
      de: 'Schwerpunkte: Maschinenkonstruktion, Fahrzeugdynamik, Strömungssimulation, Strukturmechanik.',
    },
  },
  {
    id: 'edu-btech',
    degree: {
      en: 'B.Tech. Mechanical Engineering',
      de: 'B.Tech. Maschinenbau',
    },
    institution: {
      en: 'Dr. A.P.J. Abdul Kalam Technical University, Lucknow, India',
      de: 'Dr. A.P.J. Abdul Kalam Technical University, Lucknow, Indien',
    },
    period: 'Aug 2014 – Jun 2018',
    details: {
      en: 'Fundamentals in thermodynamics, fluid mechanics, machine design, and manufacturing processes.',
      de: 'Grundlagen der Thermodynamik, Strömungsmechanik, Maschinenkonstruktion und Fertigungstechnik.',
    },
  },
];

export const skills = {
  design: {
    titleEn: 'Design Tools',
    titleDe: 'Konstruktionswerkzeuge',
    items: [
      { name: 'Autodesk Inventor', level: 92 },
      { name: 'ANSYS SpaceClaim', level: 88 },
      { name: 'ANSYS DesignModeler', level: 85 },
      { name: 'PrePoMax', level: 82 },
      { name: 'FreeCAD', level: 75 },
      { name: 'MS Office (Word, Excel, PowerPoint)', level: 90 },
    ],
  },
  simulation: {
    titleEn: 'Simulation',
    titleDe: 'Simulation',
    items: [
      { name: 'ANSYS Mechanical (FEA)', level: 90 },
      { name: 'ANSYS Fluent (CFD)', level: 88 },
      { name: 'FEM Methodology', level: 88 },
      { name: 'CAD Modelling', level: 90 },
    ],
  },
  engineering: {
    titleEn: 'Engineering Knowledge',
    titleDe: 'Ingenieurwissen',
    items: [
      { name: 'Fluid Mechanics', level: 90 },
      { name: 'Computational Fluid Dynamics', level: 85 },
      { name: 'Braking Systems', level: 82 },
      { name: 'Machine Elements', level: 85 },
    ],
  },
  programming: {
    titleEn: 'Programming',
    titleDe: 'Programmierung',
    items: [
      { name: 'Python', level: 85 },
      { name: 'MATLAB', level: 80 },
    ],
  },
};

// Soft skills — shown as a non-bar list on the Skills page
export const softSkills = [
  {
    en: 'Analytical thinking',
    de: 'Analytisches Denken',
  },
  {
    en: 'Structured problem-solving',
    de: 'Strukturierte Problemlösung',
  },
  {
    en: 'Team player',
    de: 'Teamfähigkeit',
  },
  {
    en: 'Leadership qualities',
    de: 'Führungskompetenz',
  },
  {
    en: 'Technical communication',
    de: 'Technische Kommunikation',
  },
];

// Cloudinary asset base — single source of truth
const CLD = 'https://res.cloudinary.com/dwoy6uzfu';

// Helpers (kept for readability)
const thesisImg = (n) => `${CLD}/image/upload/${n}`;
const thesisVid = (n) => `${CLD}/video/upload/${n}`;

export const projects = [
  /* =========================================================
     PROJECT 1 — Master Thesis (2025)
     ========================================================= */
  {
    id: 'torsion-spring-fem',
    year: '2025',
    context: { en: 'Master Thesis', de: 'Masterarbeit' },
    title: {
      en: 'Automated Generation & FEM Analysis of Torsion Springs with Variable Leg Geometries',
      de: 'Automatisierte Erstellung und FEM-Analyse von Drehfedern mit variablen Schenkelgeometrien und Belastungskonfigurationen',
    },
    summary: {
      en: 'Parametric Python / FreeCAD toolchain that generates torsion-spring geometries (tangential, radial, axial) and validates local stress fields via FEM against DIN EN 13906-3.',
      de: 'Parametrische Python/FreeCAD-Toolchain zur Erstellung von Drehfeder-Geometrien (tangential, radial, axial) mit FEM-Validierung der lokalen Spannungsfelder gegenüber DIN EN 13906-3.',
    },
    thumbnail: thesisImg('v1776552529/radial-gen_ifcdkw.png'),
    media: [
      {
        type: 'image',
        src: thesisImg('v1776552529/radial-GUI_dms1fd.png'),
        caption: {
          en: 'Python GUI for parametric spring-geometry input',
          de: 'Python-GUI zur parametrischen Eingabe der Feder-Geometrie',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/radial-gen_ifcdkw.png'),
        caption: {
          en: 'Automatically generated radial torsion spring in FreeCAD',
          de: 'Automatisch erzeugte radiale Drehfeder in FreeCAD',
        },
      },
      {
        type: 'video',
        src: thesisVid('v1776552561/video_erstellung_2_ea1rlw.mp4'),
        caption: {
          en: 'Automated geometry generation from the Python toolchain',
          de: 'Automatisierte Geometrieerstellung durch die Python-Toolchain',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/radial_spline_inventor_pxtwhz.png'),
        caption: {
          en: 'Radial leg spline — mathematical model in Autodesk Inventor',
          de: 'Radialer Schenkel-Spline – mathematisches Modell in Autodesk Inventor',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/tangential-spline-FreeCAD_orxsg4.png'),
        caption: {
          en: 'Tangential leg spline implementation in FreeCAD',
          de: 'Umsetzung des tangentialen Schenkel-Splines in FreeCAD',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/tangential_excel_berechnung_ym8fvh.png'),
        caption: {
          en: 'Analytical calculation of tangential spring parameters (Excel)',
          de: 'Analytische Berechnung der tangentialen Federparameter (Excel)',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/werkzeug_radial_wyn54c.png'),
        caption: {
          en: '2D iterative design of the complete coiling tool — dorn fixed to the lower plate, upper plate with rotating cylinder, used as contact partner in FEM.',
          de: '2D-iteratives Konstruktionskonzept des gesamten Wickelwerkzeugs – Dorn an der unteren Platte fixiert, obere Platte mit rotierendem Zylinder, als Kontaktpartner in der FEM eingesetzt.',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552529/Feder-kanten-nach_mabybc.png'),
        caption: {
          en: 'Mesh refinement at spring edges — critical stress region',
          de: 'Netzverfeinerung an den Federkanten – kritischer Spannungsbereich',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552530/radial_simulation_ss_d7vqbs.png'),
        caption: {
          en: 'Radial spring — FEM von-Mises stress (PrePoMax / CalculiX). Peak stress concentrates at the inner-to-leg transition where the helix body bends sharply; this is where fatigue cracks initiate. FEM captures this localisation that a DIN-based analytical estimate inherently misses, enabling correct fillet and material choices.',
          de: 'Radiale Feder – Vergleichsspannung nach von Mises (PrePoMax / CalculiX). Die Spitzenspannung konzentriert sich am Übergang vom Federkörper zum Schenkel, wo die Helix scharf abknickt – genau dort entstehen Ermüdungsrisse. Die FEM erfasst diese Lokalisierung, die eine analytische Berechnung nach DIN grundsätzlich nicht abbildet, und ermöglicht so eine korrekte Verrundungs- und Werkstoffwahl.',
        },
      },
      {
        type: 'image',
        src: thesisImg('v1776552531/tangential_simulation_ss_so75lu.png'),
        caption: {
          en: 'Tangential spring — stress distribution showing the global peak of ~1506 MPa at the transition zone. The result proves that, for torsion springs with eccentric loading, stress in the leg transition — not the coil body — is the fatigue-critical region. Designing against this allows mass and package reduction without sacrificing reliability.',
          de: 'Tangentiale Feder – Spannungsverteilung mit globalem Maximum von ca. 1506 MPa in der Übergangszone. Das Ergebnis belegt, dass bei Drehfedern mit exzentrischer Belastung nicht der Federkörper, sondern der Schenkel-Übergang der dauerfestigkeitskritische Bereich ist. Eine darauf abgestimmte Auslegung ermöglicht Masse- und Bauraumreduktion ohne Zuverlässigkeitsverlust.',
        },
      },
      {
        type: 'video',
        src: thesisVid('v1776552551/radial_drehfedern_drauf_tyjik4.mp4'),
        caption: {
          en: 'Radial torsion spring — FEM loading simulation (top view)',
          de: 'Radiale Drehfeder – FEM-Lastsimulation (Draufsicht)',
        },
      },
      {
        type: 'video',
        src: thesisVid('v1776552531/tangential_drehfedern_drauf_vdpttf.mp4'),
        caption: {
          en: 'Tangential torsion spring — FEM loading simulation',
          de: 'Tangentiale Drehfeder – FEM-Lastsimulation',
        },
      },
      {
        type: 'video',
        src: thesisVid('v1776552548/axial_drehfedern_vorder_q1xlsz.mp4'),
        caption: {
          en: 'Axial torsion spring — FEM loading simulation (front view)',
          de: 'Axiale Drehfeder – FEM-Lastsimulation (Vorderansicht)',
        },
      },
    ],
    problem: {
      en: 'Analytical standards for torsion-spring design (DIN EN 13906-3) strongly simplify the leg geometry and therefore miss local stress concentrations in the transition zones between coil body and leg. The result is over-conservative, over-dimensioned springs — a real constraint for automotive applications such as brake-pedal return springs, where packaging and mass matter.',
      de: 'Die analytische Normung zur Drehfederauslegung (DIN EN 13906-3) vereinfacht die Schenkelgeometrie stark und erfasst lokale Spannungsspitzen in den Übergangszonen zwischen Federkörper und Schenkel nicht. Das führt zu überdimensionierten Federn – eine reale Einschränkung für Automobilanwendungen wie Rückstellfedern im Bremspedal, bei denen Bauraum und Masse entscheidend sind.',
    },
    objective: {
      en: 'Develop an automated Python-driven workflow that parametrically generates torsion-spring geometries (tangential, radial and axial leg variants), runs FEM analyses to capture the full local stress field, and benchmarks the results against DIN-based analytical calculations.',
      de: 'Entwicklung eines automatisierten Python-gestützten Workflows zur parametrischen Erstellung von Drehfeder-Geometrien (tangentiale, radiale und axiale Schenkelvarianten) mit anschließender FEM-Analyse der lokalen Spannungsverteilung und Benchmark gegen DIN-basierte analytische Rechnungen.',
    },
    approach: {
      en: [
        'Derived mathematical descriptions for the helix body, transition zones and three leg geometries (tangential, radial, axial).',
        'Implemented parametric geometry generation in FreeCAD driven by Python, including a GUI for parameter input and automated STEP export.',
        'Built the FEM pre- / post-processing pipeline in PrePoMax with the CalculiX solver: meshing, contact definition against the tool / dorn, material assignment and solver tuning (PaStiX for faster convergence).',
        'Applied realistic boundary conditions — fixed lower leg, controlled rotation on the upper leg — and ran parameter studies over friction (μ = 0.1 / 0.15), lever-arm length and transition radius rb.',
        'Post-processed principal-stress histories at critical nodes in the transition zones and compared the three spring variants under identical loading.',
        'Benchmarked FEM results against closed-form DIN EN 13906-3 calculations implemented in Excel.',
      ],
      de: [
        'Mathematische Beschreibung für Federkörper, Übergangszonen und drei Schenkelgeometrien (tangential, radial, axial) hergeleitet.',
        'Parametrische Geometrieerstellung in FreeCAD Python-gesteuert umgesetzt – inklusive GUI für die Parametereingabe und automatischem STEP-Export.',
        'FEM-Pre- und Postprocessing-Pipeline in PrePoMax mit CalculiX-Solver aufgebaut: Vernetzung, Kontaktdefinition gegen Werkzeug / Dorn, Materialzuweisung und Solver-Tuning (PaStiX für schnellere Konvergenz).',
        'Realistische Randbedingungen angewendet – unterer Schenkel fixiert, oberer Schenkel mit kontrollierter Rotation – und Parameterstudien über Reibung (μ = 0,1 / 0,15), Hebelarmlänge und Übergangsradius rb durchgeführt.',
        'Hauptspannungsverläufe an kritischen Knoten in den Übergangszonen ausgewertet und die drei Federvarianten unter identischer Last verglichen.',
        'FEM-Ergebnisse gegen analytische Berechnungen nach DIN EN 13906-3 in Excel benchmarkiert.',
      ],
    },
    tools: ['Python', 'FreeCAD', 'Autodesk Inventor', 'PrePoMax', 'CalculiX', 'Microsoft Excel'],
    results: {
      en: [
        'Delivered a fully automated geometry toolchain (Python + FreeCAD + GUI) that outputs ready-to-mesh STEP files for three leg-geometry variants.',
        'Tangential variant reached a peak equivalent stress of ~1506 MPa (μ = 0.1, lever arm 7.5 mm, 180° leg position) — the transition zone, not the coil body, is the dominant stress driver.',
        'Longer lever arms and higher friction systematically raised transition-zone stresses; a larger transition radius rb redistributed the peak over a wider area.',
        'DIN-based analytical methods were shown to be both over- and under-conservative depending on the configuration — FEM is required for a reliable local validation.',
      ],
      de: [
        'Vollständig automatisierte Geometrie-Toolchain (Python + FreeCAD + GUI) umgesetzt, die vernetzungsfertige STEP-Dateien für drei Schenkelvarianten ausgibt.',
        'Die tangentiale Variante erreichte eine Spitzen-Vergleichsspannung von ca. 1506 MPa (μ = 0,1, Hebelarm 7,5 mm, Schenkel-Stellung 180°) – der dominierende Spannungstreiber ist die Übergangszone, nicht der Federkörper.',
        'Längere Hebelarme und höhere Reibung erhöhten systematisch die Spannungen in der Übergangszone; ein größerer Übergangsradius rb verteilte die Spitzenspannung auf eine größere Fläche.',
        'Analytische Verfahren nach DIN können je nach Konfiguration sowohl konservativ als auch nicht-konservativ sein – für eine belastbare lokale Validierung ist FEM unverzichtbar.',
      ],
    },
    learnings: {
      en: 'The local leg geometry — not the coil body — dominates the real stress state of torsion springs under eccentric loading. Script-driven CAD paired with open-source FEM (FreeCAD + CalculiX) reaches commercial-grade accuracy at zero licence cost and is a realistic basis for an automotive-supplier design workflow.',
      de: 'Die lokale Schenkelgeometrie – nicht der Federkörper – dominiert den realen Spannungszustand von Drehfedern unter exzentrischer Belastung. Skriptgetriebene CAD-Erstellung in Kombination mit Open-Source-FEM (FreeCAD + CalculiX) erreicht die Genauigkeit kommerzieller Werkzeuge bei Null Lizenzkosten und ist eine realistische Basis für einen Auslegungs-Workflow beim Automobilzulieferer.',
    },
    conclusion: {
      en: 'This thesis demonstrates how an end-to-end, script-driven CAD + FEM workflow replaces weeks of manual iteration and exposes a stress concentration that conventional DIN methods miss. The insight — that leg geometry, not the coil body, governs fatigue — directly informs lighter, more reliable torsion-spring designs for automotive packaging-critical applications such as brake-pedal return springs. The framework is extensible to any wire-formed component and shows the value of combining engineering first principles with automation.',
      de: 'Die Arbeit zeigt, wie ein durchgängiger, skriptgetriebener CAD + FEM-Workflow wochenlange manuelle Iteration ersetzt und eine Spannungskonzentration aufdeckt, die klassische DIN-Methoden nicht erfassen. Die Erkenntnis – dass die Schenkelgeometrie und nicht der Federkörper die Lebensdauer bestimmt – fließt direkt in leichtere, zuverlässigere Drehfederauslegungen für bauraumkritische Automobilanwendungen wie Bremspedal-Rückstellfedern ein. Das Framework ist auf beliebige drahtgeformte Bauteile übertragbar und belegt den Mehrwert der Kombination aus ingenieurtechnischen Grundprinzipien und Automatisierung.',
    },
  },

  /* =========================================================
     PROJECT 2 — Projekt-Seminar: Tire CFD + DPM (2023)
     ========================================================= */
  {
    id: 'tire-cfd-dpm',
    year: '2023',
    context: { en: 'Project Seminar', de: 'Projekt-Seminar' },
    title: {
      en: 'CFD of Different Tire Profiles — Flow & Wear-Particle Trajectory Analysis',
      de: 'Reifensimulation verschiedener Profilgeometrien und Analyse der Auswirkungen auf Strömung und Partikeltrajektorien',
    },
    summary: {
      en: 'CFD study of slicks, summer, winter and all-season tires using the Rough-Wall-Method (RWM) and Moving-Reference-Frame (MRF) approaches, coupled with the Discrete-Phase Model (DPM) for tire-wear particle trajectories.',
      de: 'CFD-Studie von Slicks, Sommer-, Winter- und Ganzjahresreifen mit den Ansätzen Rough-Wall-Method (RWM) und Moving-Reference-Frame (MRF), gekoppelt mit dem Discrete-Phase-Model (DPM) zur Auswertung der Partikeltrajektorien von Reifenabrieb.',
    },
    thumbnail: `${CLD}/image/upload/v1776552533/velocity-contour_fcgsvb.png`,
    media: [
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552544/Reifen_bwvomg.jpg`,
        caption: {
          en: 'Reference tire — geometry starting point for CAD reconstruction',
          de: 'Referenzreifen – geometrischer Ausgangspunkt für die CAD-Rekonstruktion',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552545/Tread2closeup_odomsj.jpg`,
        caption: {
          en: 'Close-up of the summer-tire tread pattern modelled in CAD',
          de: 'Nahaufnahme des in CAD modellierten Sommerreifen-Profils',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552533/slicks_kkm4uy.jpg`,
        caption: {
          en: 'Slicks baseline — smooth-tread reference case',
          de: 'Slicks als Referenzfall ohne Profilierung',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552533/domain-slicks_li9byo.jpg`,
        caption: {
          en: 'Fluid domain around the slicks tire used for the CFD set-up',
          de: 'Fluiddomäne um den Slick-Reifen für den CFD-Aufbau',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552533/Combine-cut_a4it8i.jpg`,
        caption: {
          en: 'Combine-Cut operation to model the tire-road contact patch ("Reifenlatsch")',
          de: 'Combine-Cut-Operation zur Modellierung der Reifenaufstandsfläche ("Reifenlatsch")',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552538/MRF-zone_jnxyuw.jpg`,
        caption: {
          en: 'Moving-Reference-Frame (MRF) rotating region around the tire',
          de: 'Moving-Reference-Frame (MRF) – rotierendes Teilgebiet um den Reifen',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552538/Tire-contact_q6umq3.jpg`,
        caption: {
          en: 'RWM treatment at the tire-road contact — sealed interface for accurate near-wall flow',
          de: 'RWM-Behandlung am Reifen-Straßen-Kontakt – abgedichtetes Interface für belastbare wandnahe Strömung',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552559/Mesh_slicks_sg244v.jpg`,
        caption: {
          en: 'Volume mesh around the slick tire (≈ 5.9 M cells) — y⁺ targeted 30–100',
          de: 'Volumennetz um den Slick-Reifen (ca. 5,9 Mio. Zellen) – y⁺ im Zielband 30–100',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552550/Mesh_gc2agg.jpg`,
        caption: {
          en: 'Mesh detail around the tread — local refinement for resolving flow separation',
          de: 'Netzausschnitt am Profil – lokale Verfeinerung zur Auflösung der Strömungsablösung',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552533/velocity-contour_fcgsvb.png`,
        caption: {
          en: 'Velocity contour showing the wake behind a tire at 60 km/h (RWM). The deep-blue low-velocity zone indicates flow separation and re-circulation — where tire-wear particles are trapped and then lifted off the road into the breathing zone. Understanding this wake shape is the key to predicting where particulate matter concentrates near the vehicle.',
          de: 'Geschwindigkeitskontur mit Totwassergebiet hinter dem Reifen bei 60 km/h (RWM). Die tiefblaue Niedriggeschwindigkeitszone zeigt Strömungsablösung und Rezirkulation – dort werden Reifenabrieb-Partikel eingefangen und anschließend aus der Fahrbahnoberfläche in den Atembereich transportiert. Das Verständnis dieser Nachlaufform ist entscheidend, um die Partikelkonzentration in Fahrzeugnähe zu prognostizieren.',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552532/Velocity-magnitude_zpzd1z.png`,
        caption: {
          en: 'Velocity magnitude — summer vs all-season tire. Summer tires produce a larger, more turbulent wake that transports particles further downstream; all-season tires show a more compact, front-loaded wake. These differences are first-order drivers of how far tire-wear particles spread in urban traffic.',
          de: 'Geschwindigkeitsbetrag – Sommerreifen vs. Ganzjahresreifen. Sommerreifen erzeugen ein größeres, turbulenteres Totwasser und transportieren Partikel weiter stromab; Ganzjahresreifen weisen ein kompakteres, vorn konzentriertes Nachlaufgebiet auf. Diese Unterschiede sind Einflussgrößen erster Ordnung dafür, wie weit sich Reifenabrieb-Partikel im Stadtverkehr ausbreiten.',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552533/DPM-concentration_isa5ck.png`,
        caption: {
          en: 'DPM particle concentration around the tire — anthracite (ρ = 2650 kg/m³) as silica-dust surrogate. High concentrations cluster at the sidewall and in the low-pressure wake; this is where inhalable PM₁₀/PM₂.₅ exposure is highest for pedestrians and cyclists. Quantifying these zones is a direct input for non-exhaust emission regulation (Euro 7).',
          de: 'DPM-Partikelkonzentration um den Reifen – Anthrazit (ρ = 2650 kg/m³) als Silikatstaub-Ersatz. Hohe Konzentrationen bilden sich an der Reifenflanke und im Niederdruckbereich des Totwassers; dort ist die einatembare PM₁₀/PM₂.₅-Belastung für Fußgänger und Radfahrer am höchsten. Die Quantifizierung dieser Zonen liefert direkte Eingangsgrößen für die Regulierung nicht-auspuffbezogener Emissionen (Euro 7).',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552539/DPM-concentrationebene1_vcukp6.png`,
        caption: {
          en: 'DPM concentration at plane 1 — the tread emission origin. Particles accumulate immediately downstream of the contact patch where flow detaches from the tread; this is the primary source region for tire-wear PM emissions into the surrounding air.',
          de: 'DPM-Konzentration in Ebene 1 – Ursprungsbereich der Profil-Emission. Partikel sammeln sich unmittelbar stromab der Aufstandsfläche, wo die Strömung vom Profil ablöst; dies ist die primäre Quellregion für Reifenabrieb-PM-Emissionen in die umgebende Luft.',
        },
      },
      {
        type: 'image',
        src: `${CLD}/image/upload/v1776552540/DPM-concentrationebene4_ikwwf3.png`,
        caption: {
          en: 'DPM concentration at plane 4 — wheel-rim area. Winter tires show a pronounced accumulation around the rim, driven by the rotating-zone flow and recirculation; summer tires remain comparatively clean here. This has direct implications for brake-disc soiling and wheel-well particle build-up.',
          de: 'DPM-Konzentration in Ebene 4 – Felgenbereich. Winterreifen zeigen eine ausgeprägte Ansammlung an der Felge, bedingt durch die Rotationszonen-Strömung und Rezirkulation; Sommerreifen bleiben hier vergleichsweise sauber. Dies hat direkten Einfluss auf die Verschmutzung von Bremsscheiben und den Partikelaufbau im Radhaus.',
        },
      },
      {
        type: 'video',
        src: `${CLD}/video/upload/v1776552551/REIFENmontage_lb1co3.mp4`,
        caption: {
          en: 'Virtual tire assembly and CAD set-up sequence',
          de: 'Virtuelle Reifenmontage und CAD-Aufbausequenz',
        },
      },
    ],
    problem: {
      en: 'Tire wear is a major source of non-exhaust particulate-matter emissions that impact urban air quality. How tire-tread geometry drives the near-tire flow field and the resulting particle trajectories is not well captured by standard analytical assumptions — a predictive CFD framework is needed.',
      de: 'Reifenabrieb ist eine wesentliche Quelle von Nicht-Auspuff-Partikelemissionen mit Einfluss auf die urbane Luftqualität. Wie die Profilgeometrie das reifennahe Strömungsfeld und damit die Partikeltrajektorien treibt, lässt sich mit klassischen analytischen Annahmen nicht abbilden – es wird ein prädiktives CFD-Framework benötigt.',
    },
    objective: {
      en: 'Build a CFD + DPM simulation framework that (a) reliably reproduces the tire-road flow field, (b) compares RWM and MRF modelling approaches, and (c) quantifies how summer, winter, all-season and slick tires differ in near-tire particle concentration.',
      de: 'Aufbau eines CFD + DPM-Simulationsrahmens, der (a) das Reifen-Straßen-Strömungsfeld zuverlässig abbildet, (b) RWM- und MRF-Ansätze vergleicht und (c) die Unterschiede zwischen Sommer-, Winter-, Ganzjahres- und Slick-Reifen in der reifennahen Partikelkonzentration quantifiziert.',
    },
    approach: {
      en: [
        'Reconstructed tire and rim CAD (slicks, summer, winter, all-season) in Autodesk Inventor and cleaned them in ANSYS SpaceClaim / DesignModeler for meshing.',
        'Defined the fluid domain and tire-road interface; used Combine-Cut operations to seal the contact patch realistically.',
        'Generated volume meshes in ANSYS Meshing with y⁺ targeted at 30–100 — cell counts ranged from ~5.9 M (slicks) through ~26 M (summer RWM) to ~70.5 M (summer MRF).',
        'Set up two modelling strategies in ANSYS Fluent: Rough-Wall-Method (RWM) with a moving ground, and Moving-Reference-Frame (MRF) with a dedicated rotating zone around the tire.',
        'Applied pressure-based solver with SST k-ω turbulence and boundary conditions at 30 / 60 / 90 km/h (inlet 8.33 m/s at 30 km/h, angular velocity 26.24 rad/s).',
        'Coupled the Discrete-Phase-Model (DPM, dense-discrete formulation) with anthracite particles (ρ = 2650 kg/m³) injected from the tread with realistic velocity components.',
        'Post-processed velocity contours and DPM concentrations on four vertical / horizontal analysis planes (Ebene 1–4) spanning emission origin, road deposition, wake and rim regions.',
      ],
      de: [
        'Reifen- und Felgengeometrien (Slicks, Sommer, Winter, Ganzjahres) in Autodesk Inventor aufgebaut und in ANSYS SpaceClaim / DesignModeler für die Vernetzung aufbereitet.',
        'Fluiddomäne und Reifen-Straßen-Interface definiert; mittels Combine-Cut-Operationen die Aufstandsfläche dicht modelliert.',
        'Volumennetze in ANSYS Meshing mit Ziel-y⁺ 30–100 erstellt – Zellzahlen von ca. 5,9 Mio. (Slicks) über ca. 26 Mio. (Sommer RWM) bis ca. 70,5 Mio. (Sommer MRF).',
        'In ANSYS Fluent zwei Modellierungsstrategien aufgesetzt: Rough-Wall-Method (RWM) mit bewegtem Boden sowie Moving-Reference-Frame (MRF) mit dediziertem rotierendem Teilgebiet.',
        'Druck-basierten Solver mit SST k-ω-Turbulenzmodell verwendet, Randbedingungen für 30 / 60 / 90 km/h (Einlass 8,33 m/s bei 30 km/h, Winkelgeschwindigkeit 26,24 rad/s).',
        'Discrete-Phase-Model (DPM, Dense-Discrete-Formulierung) mit Anthrazit-Partikeln (ρ = 2650 kg/m³) gekoppelt – Einspritzung am Profil mit realistischen Geschwindigkeitskomponenten.',
        'Geschwindigkeitsfelder und DPM-Konzentrationen auf vier Auswertungsebenen (Ebene 1–4) nachbearbeitet – von Partikel-Entstehung über Fahrbahnablage bis Totwasser- und Felgenbereich.',
      ],
    },
    tools: ['ANSYS Fluent', 'ANSYS Meshing', 'ANSYS SpaceClaim', 'Autodesk Inventor', 'Python (batch jobs)'],
    results: {
      en: [
        'RWM proved superior for capturing near-tire particle phenomena — significantly higher DPM concentrations at sidewall and tread compared to MRF, consistent with physically-expected behaviour.',
        'Summer tires produced the largest near-tire DPM concentration (plane 1 and plane 3) at 30 km/h; winter tires showed a distinct accumulation in the rim area (plane 4).',
        'All-season tires exhibited the most favourable front-wake shape; winter tires showed the smallest rear wake; summer tires the largest wake overall.',
        'Higher speeds (30 → 90 km/h) enlarged and intensified the wake region; unexpected time-stepping limits were identified for slicks at 90 km/h — flagged as an area for future refinement.',
      ],
      de: [
        'RWM erwies sich als besser geeignet zur Abbildung reifennaher Partikelphänomene – deutlich höhere DPM-Konzentrationen an Flanke und Profil als bei MRF, konsistent mit der physikalisch erwarteten Signatur.',
        'Sommerreifen zeigten bei 30 km/h die höchste reifennahe DPM-Konzentration (Ebene 1 und Ebene 3); Winterreifen wiesen eine ausgeprägte Ansammlung im Felgenbereich auf (Ebene 4).',
        'Ganzjahresreifen zeigten die günstigste vordere Nachlaufform; Winterreifen das kleinste hintere Totwassergebiet; Sommerreifen das insgesamt größte Totwasser.',
        'Höhere Geschwindigkeiten (30 → 90 km/h) vergrößerten und intensivierten das Totwassergebiet; bei Slicks und 90 km/h wurden Zeitschritt-Limitierungen identifiziert – vermerkt als Punkt für künftige Verfeinerung.',
      ],
    },
    learnings: {
      en: 'Tread geometry, wall treatment and the chosen rotation approach (RWM vs MRF) are all first-order drivers of the predicted particle field — the numerical framework must be chosen alongside the physical question. A coupled Fluent + DPM workflow is a viable quantitative tool for comparing tire designs from an environmental-emissions perspective.',
      de: 'Profilgeometrie, Wandbehandlung und die gewählte Rotationsmethode (RWM vs. MRF) sind gleichermaßen Einflussgrößen erster Ordnung auf das vorhergesagte Partikelfeld – das numerische Framework muss gemeinsam mit der physikalischen Fragestellung gewählt werden. Ein gekoppelter Fluent + DPM-Workflow ist ein belastbares quantitatives Werkzeug zum Vergleich von Reifendesigns unter Umweltemissionsgesichtspunkten.',
    },
    conclusion: {
      en: 'This study delivers a validated CFD + DPM framework that quantifies how tire tread geometry drives near-vehicle particulate-matter exposure — a growing regulatory concern under Euro 7. The comparison of RWM and MRF approaches establishes a defensible numerical baseline, and the tire-type ranking (summer vs winter vs all-season) gives OEMs and regulators a data-driven basis for emission-aware tread design. The workflow transfers directly to aerodynamic soiling, brake-dust dispersion and other non-exhaust emission studies.',
      de: 'Die Arbeit liefert ein validiertes CFD + DPM-Framework, das quantifiziert, wie die Profilgeometrie die Partikelbelastung in Fahrzeugnähe steuert – ein unter Euro 7 zunehmend relevanter regulatorischer Aspekt. Der Vergleich der RWM- und MRF-Ansätze etabliert eine belastbare numerische Basis, und die Reihung nach Reifentyp (Sommer vs. Winter vs. Ganzjahres) bietet OEMs und Regulierungsbehörden eine datengestützte Grundlage für emissionsbewusste Profilgestaltung. Der Workflow ist direkt auf aerodynamische Verschmutzung, Bremsstaubverteilung und weitere Nicht-Auspuff-Emissionsstudien übertragbar.',
    },
  },
];


export const getProjectsChronological = (order = 'desc') => {
  const sorted = [...projects].sort((a, b) => Number(a.year) - Number(b.year));
  return order === 'desc' ? sorted.reverse() : sorted;
};

export const getProjectById = (id) => projects.find((p) => p.id === id);
